import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toEnumKey',
    standalone: false
})
export class ToEnumKeyPipe implements PipeTransform {
  transform(value: string | number, enumType: Record<string, unknown>): string {
    const keys = Object.keys(enumType).filter((key) => enumType[key] === value);
    return keys.length > 0 ? keys[0] : '';
  }
}
